'use es6';

export const EDIT = 'EDIT';
export const CREATE = 'CREATE';